// Static content for "The Bar" landing page
export const VENUE = {
  name: "The Bar",
  tagline: "GREAT DRINKS • GREAT TIMES • GREAT PEOPLE",
  address: "27 Murray Street, Colac, Victoria, 3250",
  hours: "Fri & Sat • 8pm – Late",
  email: "thebarcolac@gmail.com",
  facebook: "https://www.facebook.com/thebarcolac",
  instagram: "https://www.instagram.com/thebarcolac",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/a25cx4t7_TheBar_Colac_COL_COASTER_LOGO.png",
};

export const WHATS_ON = [
  {
    day: "WEEKENDS",
    title: "Karaoke",
    blurb:
      "Grab the mic, grab a pint. Our karaoke setup has seen its share of fearless performances — pop your name on the list and own the room.",
    time: "SEE EVENTS",
  },
  {
    day: "WEEKENDS",
    title: "Live Music",
    blurb:
      "Local legends, touring acts and unforgettable nights. The stage is loud, the crowd is louder. Check the lineup for who's next.",
    time: "SEE EVENTS",
  },
  {
    day: "ANY NIGHT",
    title: "Private Hire",
    blurb:
      "Birthdays, work parties, engagements — make it yours. Drop us a line and we'll sort the rest.",
    time: "BY ARRANGEMENT",
  },
];

export const EVENTS = [
  {
    id: 1,
    date: { day: "12", month: "DEC" },
    title: "Karaoke Friday: Christmas Edition",
    type: "KARAOKE",
    description:
      "Tinsel, terrible singing and tequila — our biggest karaoke night of the year.",
    fbUrl: "https://www.facebook.com/events/",
  },
  {
    id: 2,
    date: { day: "13", month: "DEC" },
    title: "The Lost Keys — Live",
    type: "LIVE MUSIC",
    description:
      "Indie rock four-piece tearing the roof off. Free entry, doors 8pm.",
    fbUrl: "https://www.facebook.com/events/",
  },
  {
    id: 3,
    date: { day: "19", month: "DEC" },
    title: "Karaoke Friday: Glow Night",
    type: "KARAOKE",
    description:
      "UV lights, glow sticks and your best Mariah impression. You bring the voice, we bring the chaos.",
    fbUrl: "https://www.facebook.com/events/",
  },
  {
    id: 4,
    date: { day: "27", month: "DEC" },
    title: "Saturday Sessions: Hank & The Hounds",
    type: "LIVE MUSIC",
    description:
      "Country-blues from the Otways. Sing-along guaranteed by the second set.",
    fbUrl: "https://www.facebook.com/events/",
  },
  {
    id: 5,
    date: { day: "02", month: "JAN" },
    title: "NYE Recovery Karaoke",
    type: "KARAOKE",
    description:
      "Wipe off the hangover and pick up the mic. Drink specials all night.",
    fbUrl: "https://www.facebook.com/events/",
  },
];

export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/rezu444g_7.png",
    alt: "Crowd dancing on a weekend at The Bar — a popular pub in Colac, VIC",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/adounfir_9.png",
    alt: "Regulars in the booth at The Bar Colac — friendly Colac bar atmosphere",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/fdv61tfc_8.png",
    alt: "Crew on the dance floor singing karaoke at The Bar Colac",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/pqeq0cno_6.png",
    alt: "Group enjoying drinks at The Bar Colac — one of the busiest pubs in Colac",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/q5gdxfto_5.png",
    alt: "Two patrons with cocktails at The Bar Colac live music venue",
  },
];

export const TESTIMONIALS = [
  {
    name: "Bec Savage",
    role: "Google review · 5★",
    quote:
      "Absolutely love this place! The second you walk in, the vibe is welcoming, fun, and perfectly balanced — great for a chill drink or a lively night out. The staff are friendly, attentive, and clearly care about making sure everyone has a great time. Drinks are top-notch, well-crafted, and fairly priced. Easily one of my favorite places to go — highly recommend checking it out!",
  },
  {
    name: "Sharon Lalic",
    role: "Google review · 5★",
    quote:
      "Kris and his team at The Bar went above and beyond to make our 20 year high school reunion the best it could be. Friendly, attentive service with great music and fantastic venue. Thank Kris and team.",
  },
  {
    name: "Peta Jubber",
    role: "Google review · 5★",
    quote:
      "Love love love the bar! The staff are all absolutely incredible! The live music is fantastic and the karaoke is… good 😂. My favourite place to go (and I've tried all of them).",
  },
];
